import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-am",
  "use": "icon-am-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-am\"><defs><style type=\"text/css\"></style></defs><path d=\"M514.6 330c-32.6 0-59.2 26.5-59.2 59.2 0 32.6 26.5 59.2 59.2 59.2 32.6 0 59.2-26.5 59.2-59.2-0.1-32.7-26.6-59.2-59.2-59.2z m247.7-186.7c-91.8 0-178.3-29.8-247.8-81.3-69.5 51.5-156 81.3-247.8 81.3-31.9 0-64.9-5.9-98.8-17.7v389.2c0 36.1 12.9 80.5 37.2 128.2 25.3 49.7 63.2 103.2 109.4 154.6 41 45.7 89 90 135 124.6 20.2 15.2 37.1 26.4 50.3 34.3 6.5 3.9 14.7 3.8 21.1-0.2 13.4-8.4 30.4-20 50.9-35.5 47.4-36.1 96.6-81 138.3-126.4 47.9-52.1 86.9-105.6 113-154.9 24.9-47 38.1-90.2 38.1-124.8V125.6c-34 11.8-67 17.7-98.9 17.7zM551.9 546.7v169.9c-0.2 20.5-16.9 36.9-37.4 36.9s-37.1-16.5-37.4-36.9V546.7c-71.3-16.9-124.6-81.1-124.6-157.6 0-89.3 72.6-161.9 161.9-161.9 89.3 0 161.9 72.6 161.9 161.9 0.2 76.5-53.1 140.7-124.4 157.6z m0 0\" p-id=\"2454\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/am.svg
// module id = Zk2g
// module chunks = 157